module.exports = __webpack_public_path__ + "img/1440.ccb55ef8.jpg";